<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "LoanApproval"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LoanApproval.vue